import { mockReviews, Review } from '@/data/reviews';

const GOOGLE_PLACES_API_KEY = import.meta.env.VITE_GOOGLE_PLACES_API_KEY;
const PLACE_ID = import.meta.env.VITE_GOOGLE_PLACE_ID;

/**
 * Fetches reviews from Google Places API or returns mock data.
 * 
 * IMPORTANT FOR PRODUCTION:
 * You cannot call the Google Places API directly from the browser (client-side) using an API key 
 * due to CORS (Cross-Origin Resource Sharing) restrictions enforced by Google and browsers.
 * 
 * To make this work in production, you must either:
 * 1. Use a proxy server or backend function (like Firebase Cloud Functions, Vercel Functions, or your own Node.js server).
 * 2. Use a specific client-side library designed for this (less common for direct API access).
 * 
 * The code below demonstrates how the fetch WOULD look if you had a proxy, 
 * or if you were calling it from a server context.
 */
export const getGoogleReviews = async (): Promise<Review[]> => {
  // If no keys are configured, return mock data immediately
  if (!GOOGLE_PLACES_API_KEY || !PLACE_ID) {
    console.log("Using mock reviews (No API keys found)");
    return mockReviews;
  }

  try {
    // Example of how to fetch if you have a proxy set up
    // const response = await fetch(`https://your-proxy-domain.com/api/reviews?place_id=${PLACE_ID}`);

    // DIRECT CALL (Will fail in browser due to CORS without a proxy):
    // const response = await fetch(
    //   `https://maps.googleapis.com/maps/api/place/details/json?place_id=${PLACE_ID}&fields=reviews&key=${GOOGLE_PLACES_API_KEY}`
    // );

    // const data = await response.json();

    // if (data.status === 'OK') {
    //   return data.result.reviews;
    // } else {
    //   console.error("Google API Error:", data.status);
    //   return mockReviews;
    // }

    // Returning mock reviews until backend proxy is set up
    return mockReviews;

  } catch (error) {
    console.error("Error fetching reviews:", error);
    return mockReviews;
  }
};
